/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BackfillProfileAssetsRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/backfill_profile_assets.pb'
import {BackfillProfileAssetsResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/backfill_profile_assets.pb'


export const backfillProfileAssets = (request: BackfillProfileAssetsRequest, options?: CashRequestOptions) => post<BackfillProfileAssetsRequest, BackfillProfileAssetsResponse>("/2.0/cash/backfill-profile-assets", request, {...options, rejectOnError: true })